export const AnimationSequences = {
  OPEN_DOUBLE_DRAWER: "openDoubleDrawer",
  CLOSE_DOUBLE_DRAWER: "closeDoubleDrawer",
  TRANSITION_SAME_LEVEL_DOUBLE_DRAWER: "transitionSameLevelDoubleDrawer",
  TRANSITION_SAME_LEVEL_DOUBLE_DRAWER_REVERSE:
    "transitionSameLevelDoubleDrawerReverse",
  TRANSITION_NEXT_LEVEL_DOUBLE_DRAWER: "transitionNextLevelDoubleDrawer",
  TRANSITION_PREVIOUS_LEVEL_DOUBLE_DRAWER:
    "transitionPreviousLevelDoubleDrawer",
  OPEN_SINGLE_DRAWER: "openSingleDrawer",
  CLOSE_SINGLE_DRAWER: "closeSingleDrawer",
  TRANSITION_NEXT_LEVEL_SINGLE_DRAWER: "transitionNextLevelSingleDrawer",
  TRANSITION_PREVIOUS_LEVEL_SINGLE_DRAWER:
    "transitionPreviousLevelSingleDrawer",
} as const;

export type AnimationSequencesType =
  (typeof AnimationSequences)[keyof typeof AnimationSequences];

export const AnimationDurations = {
  highlight: 200,
  drawerContent: 250,
  drawer: 400,
  backdrop: 400,
  drawerOpen: 600,
};
